/** Plain-language cue at the top of each wizard step. */

export function PhaseInstruction({ children }: { children: React.ReactNode }) {
  return <p className="text-sm text-slate-300 leading-relaxed">{children}</p>;
}
